import React, { memo } from 'react';
import { Space, Avatar } from 'antd';
import { PoweroffOutlined } from '@ant-design/icons';
import { useTheme } from 'contexts/theme';
import ThemeSwitch from '../theme';
import User from '../user';
import Menu from '../menu';

import styles from './header.module.sass';
import { logout } from 'redux/modules/user/slice';
import { removeUser } from 'utils/storage.service';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { dark } = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeUser();
    dispatch(logout());
    parent.location.href = '/';
    // navigate('/login');
  };

  return (
    <div className={dark ? styles['header-dark'] : styles.header}>
      <Space>
        <Menu />
        <a href="/">
          <div className={styles.logo}>
            <img src="/line-drive-logo.png" alt="Line Drive" />
          </div>
        </a>
      </Space>
      <Space>
        <ThemeSwitch />
        <User />
        <div onClick={handleLogout}>
          <Avatar shape="square" icon={<PoweroffOutlined />} />
        </div>
      </Space>
    </div>
  );
};

export default memo(Header);
